import { render } from "./Single.vue?vue&type=template&id=5a28a830"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"
script.render = render

export default script